var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.comments)?_c('div',_vm._l((_vm.comments),function(comment){return _c('Comment',{key:comment.id,attrs:{"comment":comment}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }